import { Stack } from 'expo-router';
import React from 'react';

function DocumentLayout() {
  return <Stack />;
}

export default DocumentLayout;
